import PreEventSection from '@src/components/layout/admin/sections/pre-event';

export default function PreEventPage() {
    return <PreEventSection title="คำขอกิจกรรมประเภท Pre-event" />;
}
